<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-user"></i> Pessoas</h3>
      </div>
    </div>
    <PersonAdd v-if="showAdd" ref="PersonAdd" v-on:Back="onBack" />
    <PersonList v-else ref="PersonList" v-on:New="onNew" v-on:Edit="onEdit"/>
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import PersonAdd from './components/add/personAdd.vue'
import PersonList from './components/list/personList.vue'

export default {
  name: 'Person',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    PersonAdd,
    PersonList
  },
  mounted () {
    // Tools.MinimizedSidebar()
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  methods: {
    onNew () {
      this.showAdd = true
    },
    onEdit (obj) {
      this.showAdd = true
      this.$nextTick(() => {
        this.$refs.PersonAdd.onEdit(obj)
      })
    },
    onBack () {
      this.showAdd = false
      // this.$refs.PersonList.onLoad()
    },
    onLoad () {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/person/person.vue